import { render, staticRenderFns } from "./sbar.vue?vue&type=template&id=0e2a789f&scoped=true"
import script from "./sbar.vue?vue&type=script&lang=js"
export * from "./sbar.vue?vue&type=script&lang=js"
import style0 from "./sbar.vue?vue&type=style&index=0&id=0e2a789f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a789f",
  null
  
)

export default component.exports